/**
 * Single source of truth for the release version + date shown in every
 * footer (dashboard, home page, marketing) AND the standalone legal HTML
 * pages under /public.
 *
 * TO BUMP THE RELEASE:
 *   node scripts/bump-release.mjs 2.5.7 "10 July 2026"
 *
 * That script rewrites this file AND public/release.json in one shot.
 * The static HTML pages read public/release.json via a tiny inline
 * script so no other page-by-page edits are needed.
 */
export const RELEASE_VERSION = 'v2.5.6';
export const RELEASE_DATE    = '06 July 2026';
export const RELEASE_LABEL   = `Release ${RELEASE_VERSION} · ${RELEASE_DATE}`;
